'use strict';
import * as $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError$0024$0024anon$00241 from "./app.data.-Google-Sign-In-Error$$anon$1.js";
import * as $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError$0024$002dOther from "./app.data.-Google-Sign-In-Error$-Other.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_data_GoogleSignInError$__PopupClosedByUser__Lapp_data_GoogleSignInError() {
  $m_Lapp_data_GoogleSignInError$();
  return $t_Lapp_data_GoogleSignInError$__PopupClosedByUser;
}
export { $s_Lapp_data_GoogleSignInError$__PopupClosedByUser__Lapp_data_GoogleSignInError as $s_Lapp_data_GoogleSignInError$__PopupClosedByUser__Lapp_data_GoogleSignInError };
function $s_Lapp_data_GoogleSignInError$__PopupBlocked__Lapp_data_GoogleSignInError() {
  $m_Lapp_data_GoogleSignInError$();
  return $t_Lapp_data_GoogleSignInError$__PopupBlocked;
}
export { $s_Lapp_data_GoogleSignInError$__PopupBlocked__Lapp_data_GoogleSignInError as $s_Lapp_data_GoogleSignInError$__PopupBlocked__Lapp_data_GoogleSignInError };
function $s_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential__Lapp_data_GoogleSignInError() {
  $m_Lapp_data_GoogleSignInError$();
  return $t_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential;
}
export { $s_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential__Lapp_data_GoogleSignInError as $s_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential__Lapp_data_GoogleSignInError };
/** @constructor */
function $c_Lapp_data_GoogleSignInError$() {
  $n_Lapp_data_GoogleSignInError$ = this;
  $t_Lapp_data_GoogleSignInError$__PopupClosedByUser = new $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError$0024$0024anon$00241.$c_Lapp_data_GoogleSignInError$$anon$1("PopupClosedByUser", 0);
  $t_Lapp_data_GoogleSignInError$__PopupBlocked = new $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError$0024$0024anon$00241.$c_Lapp_data_GoogleSignInError$$anon$1("PopupBlocked", 1);
  $t_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential = new $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError$0024$0024anon$00241.$c_Lapp_data_GoogleSignInError$$anon$1("AccountExistsWithDifferentCredential", 2);
}
export { $c_Lapp_data_GoogleSignInError$ as $c_Lapp_data_GoogleSignInError$ };
$p = $c_Lapp_data_GoogleSignInError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_GoogleSignInError$;
/** @constructor */
function $h_Lapp_data_GoogleSignInError$() {
}
export { $h_Lapp_data_GoogleSignInError$ as $h_Lapp_data_GoogleSignInError$ };
$h_Lapp_data_GoogleSignInError$.prototype = $p;
$p.bJb = (function(err) {
  var msg = err.gw();
  return (((msg.indexOf("auth/popup-closed-by-user") | 0) !== (-1)) ? $s_Lapp_data_GoogleSignInError$__PopupClosedByUser__Lapp_data_GoogleSignInError() : (((msg.indexOf("auth/popup-blocked") | 0) !== (-1)) ? $s_Lapp_data_GoogleSignInError$__PopupBlocked__Lapp_data_GoogleSignInError() : (((msg.indexOf("auth/account-exists-with-different-credential") | 0) !== (-1)) ? $s_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential__Lapp_data_GoogleSignInError() : new $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError$0024$002dOther.$c_Lapp_data_GoogleSignInError$Other($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_ThrowableExts$package$().a56(err)))));
});
$p.dl = (function(x) {
  return x.co();
});
var $d_Lapp_data_GoogleSignInError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_GoogleSignInError$, "app.data.GoogleSignInError$", ({
  DK: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_GoogleSignInError$ as $d_Lapp_data_GoogleSignInError$ };
var $n_Lapp_data_GoogleSignInError$;
function $m_Lapp_data_GoogleSignInError$() {
  if ((!$n_Lapp_data_GoogleSignInError$)) {
    $n_Lapp_data_GoogleSignInError$ = new $c_Lapp_data_GoogleSignInError$();
  }
  return $n_Lapp_data_GoogleSignInError$;
}
export { $m_Lapp_data_GoogleSignInError$ as $m_Lapp_data_GoogleSignInError$ };
var $t_Lapp_data_GoogleSignInError$__PopupClosedByUser = null;
function $u_Lapp_data_GoogleSignInError$__PopupClosedByUser(x) {
  $t_Lapp_data_GoogleSignInError$__PopupClosedByUser = x;
}
export { $t_Lapp_data_GoogleSignInError$__PopupClosedByUser as $t_Lapp_data_GoogleSignInError$__PopupClosedByUser, $u_Lapp_data_GoogleSignInError$__PopupClosedByUser as $u_Lapp_data_GoogleSignInError$__PopupClosedByUser };
var $t_Lapp_data_GoogleSignInError$__PopupBlocked = null;
function $u_Lapp_data_GoogleSignInError$__PopupBlocked(x) {
  $t_Lapp_data_GoogleSignInError$__PopupBlocked = x;
}
export { $t_Lapp_data_GoogleSignInError$__PopupBlocked as $t_Lapp_data_GoogleSignInError$__PopupBlocked, $u_Lapp_data_GoogleSignInError$__PopupBlocked as $u_Lapp_data_GoogleSignInError$__PopupBlocked };
var $t_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential = null;
function $u_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential(x) {
  $t_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential = x;
}
export { $t_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential as $t_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential, $u_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential as $u_Lapp_data_GoogleSignInError$__AccountExistsWithDifferentCredential };
//# sourceMappingURL=app.data.-Google-Sign-In-Error$.js.map
